import { apiSlice } from "../../api/apiSlice";

export const aiSearchAnalyticsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAiSearchOverview: builder.query({
      query: ({ startDate, endDate, state }) => {
        const params = new URLSearchParams({
          startDate: startDate || "",
          endDate: endDate || "",
          state: state || "",
        });
        return `/api/v1/admin/ai-search-analytics/overview?${params.toString()}`;
      },
    }),
    getAiSearchLogs: builder.query({
      query: ({ page, limit, search, startDate, endDate, state }) => {
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
          search: search || "",
          startDate: startDate || "",
          endDate: endDate || "",
          state: state || "",
        });
        return `/api/v1/admin/ai-search-analytics/listing?${params.toString()}`;
      },
    }),
  }),
});

export const { useGetAiSearchOverviewQuery, useGetAiSearchLogsQuery } =
  aiSearchAnalyticsApiSlice;
